import {getTotensRepository,updateStatusTotemRepository} from '@/repositories/totem.repository'


export const getTotens = async () => {
  const totens =  await getTotensRepository()

  if (!totens) {
    return null
  }

  return totens;
}

export const updateStatusTotem = async (totem, isToCreateLog = false) => {
  await updateStatusTotemRepository(totem, isToCreateLog);
}